import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import ErrorPage from './ErrorPage';

interface UnexpectedErrorPageProps {
    stack: string | undefined;
}

export const UnexpectedErrorPage = ({ stack }: UnexpectedErrorPageProps) => (
    <ErrorPage
        status={500}
        title={
            "Unexpected error occurred, and we're working to fix the problem."
        }
        stack={stack}
    />
);

const RouteErrorBoundary = () => {
    const error = useRouteError() as Error;
    if (isRouteErrorResponse(error)) {
        if (error.status === 503) {
            return (
                <ErrorPage
                    status={error.status}
                    title={'Service is currently unavailable, try again later!'}
                />
            );
        }
        if (error.status === 401) {
            return (
                <ErrorPage
                    status={error.status}
                    title={'You are not authorized to see this page.'}
                />
            );
        }
        if (error.status === 404) {
            return (
                <ErrorPage
                    status={error.status}
                    title={"Couldn't find the page you were looking for."}
                />
            );
        }
    }

    return (
        <UnexpectedErrorPage
            stack={error?.stack || 'No stack trace available'}
        />
    );
};

export default RouteErrorBoundary;
